import { AdminApi } from 'stylemix-vue-admin'

export default class Api extends AdminApi {
  constructor(airportId, parameters) {
    super(`airports/${airportId}/companies`, parameters)
  }

  makeMain(companyId) {
    return this.submit('post', `${this.endpoint}/${companyId}/main`)
  }
}



